module.exports = __webpack_public_path__ + "img/payment-klarnasofort.94570c5.svg";